import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useEndPoint } from "../../../Hooks/useEndPoint";
import SearchInput from "../../SearchInput/SearchInput"


const SearchEndPoint = forwardRef(({label,placeholder,masterType,filterData,defaultValue,onUpdate,disabled=false},ref) => {

    let {api,renderResult,searchKey,getKey,queryKey} = useEndPoint(masterType);  // Fetching endpoint for platfrom specific
    const [value,setValue] = useState(undefined);

    // Process defaultValue - if it contains "|", take the first part, otherwise keep it same
    const processedDefaultValue = defaultValue && typeof defaultValue === 'string' && defaultValue.includes('|') 
        ? defaultValue.split('|')[0] 
        : defaultValue;

    useImperativeHandle(ref,()=>({
        getValue:()=>{
            if(masterType==='EMPLOYEE') return value?`${value[getKey]}|${value.code}|${value.email}`:undefined;
            return value?value[getKey]:undefined;
        },
        value: value?value[getKey]:undefined,
        setValue:(value=undefined)=>{
            setValue(value);
        }
    }))

    let payload = undefined;
    if(masterType==='DEPARTMENT'&& filterData && filterData['officeId']) {
        payload = {
            officeId:filterData['officeId']
        }
    }
    
    
    return(
          <SearchInput 
             queryKey={queryKey}
             selected={processedDefaultValue}
             label={label} 
             placeholder={placeholder}
             api={api}
             onSelect={(value) => {
                setValue(value);
                let updateValue;
                if(masterType==='EMPLOYEE') {
                    updateValue = value?`${value[getKey]}|${value.code}|${value.email}`:undefined;
                } else {
                    updateValue = value?value[getKey]:undefined;
                }
                onUpdate(updateValue);
             }}
             disabled={disabled}
             renderResult={renderResult}
             className="mb2"
             searchKey={searchKey}
             payload={payload}
            />
    )
})

export default SearchEndPoint;